<template>
  <ul v-show="visible" class="sg-select-group__wrap">
    <li class="sg-select-group__title">{{ label }}</li>
    <li>
      <ul class="sg-select-group">
        <slot></slot>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts">
import {
  defineComponent,
  provide,
  inject,
  ref,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  toRaw,
} from 'vue'
import { SelectGroupContextKey, SelectContextKey, SelectContext } from './token'

export default defineComponent({
  name: 'SgOptionGroup',
  componentName: 'SgOptionGroup',

  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const visible = ref(true)
    const instance = getCurrentInstance()
    const children = ref([])

    provide(
      SelectGroupContextKey,
      reactive({
        ...toRefs(props),
      })
    )

    const select = inject(SelectContextKey)

    onMounted(() => {
      instance ? children.value = flattedChildren(instance.subTree) : ''
    })

    // get all instances of options
    const flattedChildren = (node) => {
      const children = []
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          if (
            child.type &&
            child.type.name === 'SgOption' &&
            child.component &&
            child.component.proxy
          ) {
            children.push(child.component.proxy as never)
          } else if (child.children?.length) {
            children.push(...flattedChildren(child))
          }
        })
      }
      return children
    }

    const { groupQueryChange } = toRaw(select as SelectContext)
    watch(groupQueryChange, () => {
      visible.value = children.value.some((option) => option['visible'] === true)
    })

    return {
      visible,
    }
  },
})
</script>
